export const CC_PATHNAME_COOKIE = "cc-pathname";
export const CC_LOCALE_COOKIE = "cc-locale";
